import { render, staticRenderFns } from "./GoodsPartnerCashForm.vue?vue&type=template&id=f3619932&scoped=true&"
import script from "./GoodsPartnerCashForm.vue?vue&type=script&lang=js&"
export * from "./GoodsPartnerCashForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3619932",
  null
  
)

export default component.exports